import React from 'react';
import Searcher from 'components/DesignSystem/Searcher';

interface FilterDatalistProps {
  datalistOptions: string[],
  categoryName: string,
  value: string,
  onChange: React.ChangeEventHandler<HTMLInputElement>
}

export default function FilterDatalist({
  datalistOptions,
  categoryName,
  value,
  onChange,
}: FilterDatalistProps) {
  const datalistId = `${categoryName}-datalist-options`;

  return (
    <>
      <Searcher
        value={value}
        onChange={onChange}
        placeholder="Pesquisar"
        list={datalistId}
      />
      <datalist id={datalistId}>
        {datalistOptions.map((option) => (
          // eslint-disable-next-line jsx-a11y/control-has-associated-label
          <option key={option} value={option} />
        ))}
      </datalist>
    </>
  );
}
